/* eslint-disable no-param-reassign */
import { createStore } from 'easy-peasy';
import storeModels from '../storeModels';

export default createStore(storeModels);
